/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, useMediaQuery } from "@chakra-ui/react"
import React, { useEffect, useRef, useState } from "react"
import { Paths } from "../common/commonConstants"
import { useGetProductMenuQuery } from "../type-and-hooks"
import { SnapMenu, type MenuBoxMasterDataType } from "./Menu/menu"
import { type MenuBoxProps } from "./Menu/menubox"

export const Header = (): JSX.Element => {
  const [headerActiveMenu, setHeaderActiveMenu] = useState<string>("")
  const menuRef = useRef(null)
  const handleClickOutside = (event: MouseEvent): void => {
    const targetElement = event.target as HTMLElement
    const menuRefElement = menuRef !== null ? (menuRef.current as unknown as HTMLElement) : null

    if (menuRefElement && !menuRefElement.contains(targetElement)) {
      setHeaderActiveMenu("")
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const menuMasterDefaultData: MenuBoxMasterDataType = [
    {
      mainMenu: "Products",
      onclickLink: Paths.Product.all,
      id: "1",
      subMenu: []
    },
    {
      mainMenu: "Reports & Resources",
      onclickLink: "/reports/all",
      id: "1",
      subMenu: [
        {
          label: "Test Reports",
          onclickLink: Paths.TEST_REPORTS
        },
        {
          label: "Installation Instructions",
          onclickLink: Paths.INSTALLATION_INSTRUCTIONS
        },
        {
          label: "Unique Solutions",
          onclickLink: Paths.UNIQUE_SOLUTIONS
        },
        {
          label: "FAQs",
          onclickLink: Paths.FAQ
        },
        {
          label: "Product Drawing & Revit Files",
          onclickLink: Paths.DRAWINGS
        },
        {
          label: "Understanding Compliance",
          onclickLink: Paths.COMPLIANCE
        },
        {
          label: "Quality Certification",
          onclickLink: Paths.QUALITY
        },
        {
          label: "Product Warranty",
          onclickLink: "WARRANTY"
        }
      ]
    },
    {
      mainMenu: "Distributors",
      onclickLink: Paths.DISTRIBUTORS,
      id: "1",
      subMenu: null
    },
    {
      mainMenu: "Contact Us",
      onclickLink: Paths.CONTACTUS,
      id: "1",
      subMenu: null
    }
  ]
  const [menuData, setMenuData] = useState<MenuBoxMasterDataType>(menuMasterDefaultData)
  const { data } = useGetProductMenuQuery({
    variables: {
      category: 0
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first"
  })

  useEffect(() => {
    if (data?.productMenu) {
      const [first, ...rest] = menuData
      const menuWithProductsFromAPI = [
        {
          mainMenu: "Products",
          onclickLink: Paths.Product.all,
          id: "1",
          subMenu: [...(data?.productMenu as MenuBoxProps[]), { label: "See All", onclickLink: Paths.Product.all }]
        },
        ...rest
      ]
      setMenuData(menuWithProductsFromAPI)
    }
  }, [data])
  const [isTouchDevice] = useMediaQuery("(hover: none)")
  const desktopMenuHeight = React.useMemo(() => (isTouchDevice ? "auto" : "114px"), [isTouchDevice])

  return (
    <Box margin="auto" minH={["auto", "auto", "auto", desktopMenuHeight]} ref={menuRef} mt="env(safe-area-inset-top)">
      {data && <SnapMenu menuMasterData={menuData} activeMenuCallBack={(event, activeMenu) => {}} />}
    </Box>
  )
}